







































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import TheLayoutDrawer from "./TheLayoutDrawer.vue";
import TheLayoutToolbar from "./TheLayoutToolbar.vue";
import TheLayoutContent from "./TheLayoutContent.vue";
// import TheLayoutFab from './TheLayoutFab.vue';
import TheLayoutToTopFab from "./TheLayoutToTopFab.vue";
// import TheLayoutFooter from "./TheLayoutFooter.vue";
import store from "../../store";
import { AxiosResponse } from "axios";
import { GetUserResponse, UsersApi } from "../../apis";

@Component({
  components: {
    TheLayoutDrawer,
    TheLayoutToolbar,
    TheLayoutContent,
    // TheLayoutFab,
    TheLayoutToTopFab,
    // TheLayoutFooter,
  },
})
export default class TheLayout extends Vue {
  // async created() {
  //   await store.dispatch("GenerateRoutes", { roles: ["admin"] });
  // }

  get email() {
    return this.$store.getters.user.email;
  }

  get navbarShow() {
    return this.$store.getters.navbarShow;
  }

  get isShowFullNavBtn() {
    if (this.$vuetify.breakpoint.width < 1366) {
      this.$store.dispatch("NavbarState", { state: false });
    }
    return this.$vuetify.breakpoint.width >= 1366;
  }

  mounted() {
    this.$nextTick(() => {
      document
        .querySelectorAll(".permission-container")
        .forEach((container) => {
          if (container.querySelectorAll(".permission-item").length < 1) {
            container.classList.add("tw-hidden");
          }
        });
    });
  }

  // @Watch("email", { immediate: true, deep: true })
  // onEmailWatch(newVal) {
  created() {
    const responseCb = (val: AxiosResponse<GetUserResponse>) => {
      if (val.status === 200) {
        const { user, permissions } = val.data.data;
        this.$store.commit("SET_USER_INFO", { user });
        this.$store.commit("SET_PERMISSIONS", { permissions });
      }
    };
    if (!this.lodash.isEmpty(this.email)) {
      new UsersApi().getCheckUser({ email: this.email }).then(responseCb);
    }
  }

  toggleNavbar() {
    this.$store.dispatch("NavbarToggle");
  }
}
